module.exports = __webpack_public_path__ + "static/img/train-bar.512e217f.png";